import { onUnmounted } from "@vue/composition-api";
export class Self {
    constructor(context) {
        this.context = context;
        onUnmounted(() => {
            for (let name in this.timers) {
                this.timerClear(name);
            }
        });
    }
    get route() {
        return this.context.root.$route;
    }
    get router() {
        return this.context.root.$router;
    }
    get store() {
        return this.context.root.$store;
    }
    t(m) {
        return this.context.root.$i18n.t(m);
    }
    emit(channel, ...params) {
        return this.context.emit(channel, ...params);
    }
    forceUpdate() {
        return this.context.parent.$children.forEach(e => e.$forceUpdate());
    }
    nextTick(callback) {
        this.context.root.$nextTick(callback);
    }
    timer(name, timeout, callback) {
        if (this.timers[name]) {
            throw new Error('Timer already exists.');
        }
        this.timers[name] = setInterval(callback, timeout);
    }
    timerClear(name) {
        if (this.timers[name]) {
            clearInterval(this.timers[name]);
            delete this.timers[name];
        }
    }
}
